import { Icon } from "../primitives/Icon";
import styles from "./ActionBar.module.css";

type Props = Readonly<{
  canBack: boolean;
  canNext: boolean;
  complete: boolean;
  onBack: () => void;
  onNext: () => void;
  onReadAll: () => void;
}>;

export function ActionBar({ canBack, canNext, complete, onBack, onNext, onReadAll }: Props) {
  return <nav className={styles.bar} data-complete={complete || undefined} aria-label="Kart kontrolleri">
    {!complete && <button type="button" onClick={onBack} disabled={!canBack}>← Geri</button>}
    <button type="button" onClick={onReadAll}><Icon name="list" /> {complete ? "Adımlara dön" : "Tümünü oku"}</button>
    {!complete && <button className={styles.primary} type="button" onClick={onNext} disabled={!canNext}>Devam <Icon name="arrow" /></button>}
  </nav>;
}
